import { db } from "../firebase";
import { collection, addDoc, serverTimestamp, query, getDocs, where } from "firebase/firestore";

/**
 * Fetches all hosts (users with role = 'host') from Firestore.
 */
export const fetchHostsFromDB = async (tenantId) => {
  try {
    let hostsQuery;
    if (tenantId) {
      hostsQuery = query(
        collection(db, "users"),
        where("role", "==", "host"),
        where("tenantId", "==", tenantId)
      );
    } else {
      hostsQuery = query(
        collection(db, "users"),
        where("role", "==", "host")
      );
    }
    const hostsSnapshot = await getDocs(hostsQuery);
    return hostsSnapshot.docs.map(doc => ({
      id: doc.id,
      uid: doc.id,
      userID: doc.data().userID,
      userName: doc.data().userName || 'Unknown Host',
      userEmailID: doc.data().userEmailID,
      hostID: doc.data().hostID || doc.data().tenantID,
      companyName: doc.data().companyName || doc.data().tenantName || 'Unknown Company',
      name: doc.data().userName || doc.data().displayName || 'Unknown Host',
      email: doc.data().userEmailID || doc.data().email,
      ...doc.data()
    }));
  } catch (error) {
    console.error("Error fetching hosts:", error);
    throw error;
  }
};

/**
 * Submits a visitor registration request.
 * - operator → direct entry to "visits" collection for checkout.
 * - appoperator → save in "visit_approvals" but auto-approved.
 * - others → save in "visit_approvals" with pending/approved status.
 */
export const submitVisitorRegistration = async (formData, userId, userRole, userEmail) => {
  try {
    const isOperator = userRole === "operator";
    const isAppOperator = userRole === "appoperator";
    const isResidential = formData.facilityType === 100;

    const commonData = {
      visitorName: formData.visitorName.trim(),
      visitorEmail: formData.visitorEmail.trim(),
      visitorMobileNo: parseInt(formData.visitorMobileNo.trim()),
      visitReason: formData.visitReason.trim(),
      tenantId: formData.tenantId,
      facilityId: formData.facilityId,
      facilityType: formData.facilityType,
      hostUserID: formData.hostUid || null,
      visitorUserID: userId || null,
      visitorTime: formData.visitorTime,
      createdBy: userId || "anonymous",
      createdByEmail: userEmail || null,
      createdByRole: userRole || "guest",
      createdAt: serverTimestamp(),
      photoUrl: formData.photoUrl || null
    };

    // RESIDENTIAL FLOW (STRICT)
    if (isResidential) {
      const visitApprovalData = {
        ...commonData,
        status: "pending"
      };

      const docRef = await addDoc(collection(db, "visit_approvals"), visitApprovalData);

      return { id: docRef.id, collection: "visit_approvals" };
    }

    // COMMERCIAL FLOW (OLD BEHAVIOR)
    if (isOperator) {
      const visitData = {
        ...commonData,
        status: "checked-in",
        checkInTime: serverTimestamp()
      };
      const docRef = await addDoc(collection(db, "visits"), visitData);
      return { id: docRef.id, collection: "visits" };
    }

    const isApproved = isOperator;

    const visitApprovalData = {
      ...commonData,
      status: isApproved ? "approved" : "pending",
      ...(isApproved && {
        approvedBy: userId || "system",
        approvedAt: serverTimestamp(),
      }),
    };

    const docRef = await addDoc(collection(db, "visit_approvals"), visitApprovalData);

    return { id: docRef.id, collection: "visit_approvals" };

  } catch (error) {
    console.error("Error submitting visit registration:", error);
    throw error;
  }
};
